<template>
    <nav class="tools d-flex flex-column align-items-center p-2">
        <button class="rounded-3 mb-2" :class="['tool', activeTool==='select' && 'active']" @click="selectTool('select')" title="Select">
            <i class="bi bi-cursor scale-50"></i>
        </button>
        <button class="rounded-3 mb-2" :class="['tool', activeTool==='pen' && 'active']" @click="selectTool('pen')" title="Pen">
            <i class="bi bi-vector-pen scale-50"></i>
        </button>
        <button class="rounded-3 mb-2" :class="['tool', activeTool==='frame' && 'active']" @click="selectTool('frame')" title="Frame">
            <i class="bi bi-slash-square scale-50"></i>
        </button>
        <button class="rounded-3 mb-2" :class="['tool', activeTool==='image' && 'active']" @click="selectTool('image')" title="Image">
            <i class="bi bi-image scale-50"></i>
        </button>
        <button class="rounded-3 mb-2" :class="['tool', activeTool==='text' && 'active']" @click="selectTool('text')" title="Text">T</button>
        <button class="rounded-3 mb-2" :class="['tool', activeTool==='hand' && 'active']" @click="selectTool('hand')" title="Hand">
            <i class="bi bi-hand-index scale-50"></i>
        </button>
    </nav>
</template>

<script>
import { Creator } from '@/lib/visionary/visionary';

export default {
    name: 'NavComp',
    props: {
        creator: {
            type: Creator,
            required: false
        },
    },
    computed: {
        activeTool() {
            if( !this.$store.state.editor.saveState ) return 'select';

            const tools = this.$store.state.editor.saveState.tools;
            const [selected_tool] = Object.keys(tools).filter(t => tools[t].selected);

            return selected_tool;
        }
    },
    methods: {
        selectTool(name) {
            this.creator.selectTool(name);
        }
    }
}
</script>

<style scoped>

.tools { 
    background: var(--panel); 
    border-right: 1px solid var(--border); 
}

.tool { 
    width: 36px; 
    height: 36px; 
    /* border: 1px solid var(--border); */
    border: none;
    /* border-radius: 24px; */
    background: var(--border); 
    color: var(--text);
    cursor: pointer; 
    font-size: 14px;
}

.tool.active, 
.tool:hover { 
    filter: brightness(1.08); 
    background: var(--accent); 
    border-color: transparent; 
}
</style>
